import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/footer/Footer";
import Login from "./Login";

const PERKS = [
  { title: "Track every order", desc: "See past purchases, redeemed vouchers and live status in one place." },
  { title: "Faster checkout", desc: "Saved details so you can buy a gift card in seconds, not minutes." },
  { title: "Concierge access", desc: "Talk to our redemption team straight from your account." },
];

const LoginPage = () => {
  return (
    <div className="gplgp-shell">
      <Navbar />

      <section className="gplgp-section">
        <div className="gplgp-bg-orb gplgp-bg-orb-tl" />
        <div className="gplgp-bg-orb gplgp-bg-orb-br" />

        <div className="gplgp-inner">
          {/* MARKETING COLUMN */}
          <div className="gplgp-marketing">
            <div className="gplgp-mkt-eyebrow">
              <span className="gplgp-mkt-dot" />
              MEMBER ACCESS
            </div>
            <h1 className="gplgp-mkt-title">
              Welcome to your <span>luxury gift card</span> destination
            </h1>
            <p className="gplgp-mkt-sub">
              Sign in to manage your orders, redeem vouchers and unlock the
              full GlobalGiftPass concierge experience.
            </p>

            <ul className="gplgp-perks">
              {PERKS.map((p, i) => (
                <li key={i}>
                  <span className="gplgp-perk-icon">
                    <svg viewBox="0 0 24 24" width="13" height="13" fill="currentColor">
                      <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                    </svg>
                  </span>
                  <div>
                    <strong>{p.title}</strong>
                    <small>{p.desc}</small>
                  </div>
                </li>
              ))}
            </ul>

            <div className="gplgp-mkt-trust">
              <span className="gplgp-mkt-pill">
                <svg width="11" height="11" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z" />
                </svg>
                PCI-DSS
              </span>
              <span className="gplgp-mkt-pill">
                <svg width="11" height="11" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6z" />
                </svg>
                3D Secure
              </span>
              <span className="gplgp-mkt-pill">
                <svg width="11" height="11" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                </svg>
                Verified Brands
              </span>
            </div>
          </div>

          {/* FORM COLUMN */}
          <div className="gplgp-form-col">
            <Login />
            <p className="gplgp-help">
              Trouble signing in?{" "}
              <Link to="/support" className="gplgp-help-link">Contact support</Link>
            </p>
          </div>
        </div>

        <style>{`
          .gplgp-shell {
            min-height: 100vh;
            background: linear-gradient(180deg, #07060a 0%, #0b0b0c 100%);
            display: flex;
            flex-direction: column;
          }
          .gplgp-section {
            position: relative;
            flex: 1;
            padding: 50px 22px 80px;
            overflow: hidden;
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
          }
          .gplgp-bg-orb {
            position: absolute;
            width: 460px; height: 460px;
            border-radius: 50%;
            filter: blur(140px);
            opacity: 0.4;
            pointer-events: none;
          }
          .gplgp-bg-orb-tl { background: rgba(212,168,87,0.18); top: -180px; left: -120px; }
          .gplgp-bg-orb-br { background: rgba(212,168,87,0.12); bottom: -200px; right: -120px; }

          .gplgp-inner {
            position: relative;
            max-width: 1100px;
            margin: 0 auto;
            display: grid;
            grid-template-columns: 1fr 480px;
            gap: 50px;
            align-items: center;
            z-index: 1;
          }

          /* MARKETING */
          .gplgp-marketing { color: #e6e8ec; }
          .gplgp-mkt-eyebrow {
            display: inline-flex; align-items: center; gap: 8px;
            padding: 6px 14px;
            background: rgba(212,168,87,0.1);
            border: 1px solid rgba(212,168,87,0.3);
            color: #d4a857;
            border-radius: 999px;
            font-size: 11px; font-weight: 700; letter-spacing: 2px;
            margin-bottom: 18px;
          }
          .gplgp-mkt-dot {
            width: 6px; height: 6px;
            border-radius: 50%;
            background: #d4a857;
            box-shadow: 0 0 10px #d4a857;
            animation: gplgp-pulse 1.6s ease-in-out infinite;
          }
          @keyframes gplgp-pulse { 0%,100% { opacity:1; transform: scale(1); } 50% { opacity:.55; transform: scale(.85); } }
          .gplgp-mkt-title {
            font-family: "Playfair Display", "Times New Roman", serif;
            font-size: 40px;
            font-weight: 700;
            color: #fff;
            margin: 0 0 14px;
            line-height: 1.15;
          }
          .gplgp-mkt-title span {
            background: linear-gradient(135deg, #f1cf85, #b58a3f);
            -webkit-background-clip: text; background-clip: text; color: transparent;
            font-style: italic; font-weight: 600;
          }
          .gplgp-mkt-sub {
            font-size: 15px;
            color: #9aa0a8;
            line-height: 1.65;
            margin: 0 0 28px;
            max-width: 480px;
          }

          .gplgp-perks {
            list-style: none; padding: 0; margin: 0 0 28px;
            display: flex; flex-direction: column; gap: 14px;
            max-width: 460px;
          }
          .gplgp-perks li {
            display: flex; align-items: flex-start; gap: 14px;
            padding: 14px 16px;
            background: rgba(255,255,255,0.02);
            border: 1px solid rgba(212,168,87,0.18);
            border-radius: 12px;
            transition: border-color .2s ease, background .2s ease;
          }
          .gplgp-perks li:hover {
            border-color: rgba(212,168,87,0.4);
            background: rgba(212,168,87,0.04);
          }
          .gplgp-perk-icon {
            width: 28px; height: 28px;
            background: rgba(212,168,87,0.16);
            border: 1px solid rgba(212,168,87,0.32);
            color: #d4a857;
            border-radius: 8px;
            display: inline-flex; align-items: center; justify-content: center;
            flex-shrink: 0;
            margin-top: 2px;
          }
          .gplgp-perks strong {
            display: block;
            font-family: "Playfair Display", serif;
            font-size: 15px;
            color: #fff;
            font-weight: 700;
            margin-bottom: 3px;
          }
          .gplgp-perks small {
            font-size: 12.5px;
            color: #9aa0a8;
            line-height: 1.5;
          }

          .gplgp-mkt-trust {
            display: flex; flex-wrap: wrap; gap: 8px;
          }
          .gplgp-mkt-pill {
            display: inline-flex; align-items: center; gap: 6px;
            padding: 5px 12px;
            background: rgba(212,168,87,0.08);
            border: 1px solid rgba(212,168,87,0.22);
            color: #d4a857;
            border-radius: 999px;
            font-size: 11px;
            font-weight: 700;
            letter-spacing: 0.6px;
            text-transform: uppercase;
          }

          /* FORM COL */
          .gplgp-form-col {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 14px;
          }
          .gplgp-help {
            font-size: 12.5px;
            color: #9aa0a8;
            margin: 0;
            text-align: center;
          }
          .gplgp-help-link {
            color: #d4a857;
            font-weight: 600;
            text-decoration: none;
          }
          .gplgp-help-link:hover { color: #f1cf85; text-decoration: underline; }

          @media (max-width: 991px) {
            .gplgp-inner {
              grid-template-columns: 1fr;
              gap: 36px;
              max-width: 520px;
            }
            .gplgp-marketing { text-align: center; }
            .gplgp-mkt-sub { margin-left: auto; margin-right: auto; }
            .gplgp-perks { margin-left: auto; margin-right: auto; }
            .gplgp-mkt-trust { justify-content: center; }
            .gplgp-mkt-title { font-size: 30px; }
          }
          @media (max-width: 575px) {
            .gplgp-section { padding: 30px 14px 60px; }
            .gplgp-mkt-title { font-size: 24px; }
            .gplgp-perks li { padding: 12px 14px; }
          }
        `}</style>
      </section>

      <Footer />
    </div>
  );
};

export default LoginPage;
